import Hero01 from "./Hero01";
import Services01 from "./Services01";
import Products01 from "./Products01";
import About01 from "./About01";

import Why01 from "./Why01";
import Banner01 from "./Banner01";
import How01 from "./How01";
import Reviews01 from "./Reviews01";
import Faq01 from "./Faq01";
import Cta01 from "./Cta01";

function main() {
  return (
    <div>
      <Hero01 />
      <Services01 />
      <Products01 />
      <About01 />
      <Why01 />
      <How01 />
      <Banner01 />
      <Reviews01 />
      <Faq01 />
      <Cta01 />
    </div>
  );
}

export default main;
